export const menusAvailableArray = [
  {
    title: 'Hearty Mains',
    items: [
      {
        name: 'Moules Marinières',
        price: '£16.95',
        description:
          'Mussels in a white wine, onion & parsley sauce served with garlic baguette slices. Add seasoned chips for £2.95.',
      },
      {
        name: 'Old English Sausage & Mash',
        price: '£15.95',
        description:
          'Old English sausages with buttery mash potato, garden peas & roast onion gravy, topped with caramelised onion chutney.',
      },
      {
        name: 'Slow Cooked Pork Belly',
        price: '£19.95',
        description:
          'With braised red cabbage, buttery mash potato, garden peas & rich gravy.',
      },
      {
        name: 'Peri Peri Chicken (GF)',
        price: '£17.95',
        description:
          'Chargrilled chicken breast marinated in a hot peri peri sauce with seasoned chips, coleslaw & crispy side salad. Plain chargrilled chicken breast available.',
      },
      {
        name: 'Fish & Chips',
        price: '£18.95',
        description:
          'Battered Atlantic cod fillet with seasoned chips, garden or mushy peas & tartare sauce. Add bread & butter for £1.99.',
      },
      {
        name: 'Lamb Hind Shank',
        price: '£19.95',
        description:
          'Slow roasted with mint & rosemary and served with rich mash potato, garden peas and mint gravy.',
      },
      {
        name: '100% British Beef or Vegetable Lasagne (V)',
        price: '£15.95',
        description:
          'Served with a crispy dressed side salad and garlic baguette slices. Add seasoned chips for £2.95.',
      },
      {
        name: 'Singapore Style Noodles (V)',
        price: '£14.45',
        description:
          'Egg noodles & mixed vegetables in a spicy oriental style sauce served with garlic baguette slices, rocket & parmesan. Add a chargrilled chicken breast for £7.',
      },
      {
        name: 'Mushroom Risotto (V)',
        price: '£14.95',
        description:
          'Champignon & cep mushrooms in a creamy risotto with parmesan, rocket & garlic baguette slices. Add a chargrilled chicken breast for £7.',
      },
      {
        name: 'Beef Chilli Con Carne (GF)',
        price: '£15.45',
        description: 'With white rice & tortilla chips.',
      },
    ],
  },
  {
    title: 'Locally Sourced Devon Pies',
    items: [
      {
        name: 'Chicken, Ham Hock & Leek',
        price: '£16.45',
        description:
          'Tender chicken, slow cooked ham hock & leeks in a creamy sauce with seasoned chips or mash potato, garden or mushy peas and a creamy pink peppercorn sauce.',
      },
      {
        name: 'Steak & Jail Ale',
        price: '£16.95',
        description:
          'Silver skirt beef in a rich Jail Ale sauce with seasoned chips or mash potato, garden or mushy peas and rich red wine gravy.',
      },
      {
        name: 'Cheese & Onion (V)',
        price: '£16.25',
        description:
          'Potato, sweet onions, mature cheddar & gruyère cheese in shortcrust pastry with either seasoned chips or mash potato, garden or mushy peas and rich roast onion gravy.',
      },
    ],
  },
  {
    title: 'Traditional Pub Basket Meals',
    items: [
      {
        name: 'Whitby Wholetail Scampi',
        price: '£13.45',
        description:
          'Eight scampi wholetails with seasoned chips, tartare sauce & lemon wedge. Add 4 scampi for £4.',
      },
      {
        name: '1/2 Roast Chicken & Chips',
        price: '£13.45',
        description:
          'Juicy 1/2 roast chicken with seasoned chips & creamy coleslaw.',
      },
      {
        name: 'Spicy Prawns',
        price: '£13.45',
        description:
          'Six king prawns in a Bengali spiced breadcrumb with seasoned chips & coleslaw. Add three prawns for £4.',
      },
      {
        name: 'Boneless Chicken Wings',
        price: '£13.45',
        description:
          'Lightly breaded boneless wings with seasoned chips & coleslaw.',
      },
      {
        name: 'Jumbo Cod Fish Fingers',
        price: '£13.45',
        description: 'With seasoned chips, tartare sauce & lemon wedge.',
      },
      {
        name: 'Southern Fried Chicken',
        price: '£13.45',
        description:
          'Three crispy southern fried goujons with seasoned chips & creamy coleslaw.',
      },
      {
        name: 'Quorn Dippers (VG)',
        price: '£13.45',
        description: 'Six crispy dippers with seasoned chips & coleslaw.',
      },
    ],
  },
  {
    title: 'Sandwiches, Snacks & Soup',
    items: [
      {
        name: 'Seasoned Chips (V)',
        price: '£4.35',
        description:
          'A mini bucket of thick cut chips in our homemade seasoning with ketchup & mayonnaise. Add melted cheddar & mozzarella for £1.99.',
      },
      {
        name: 'Onion Rings (V)',
        price: '£3.95',
        description:
          'Eight crispy battered onion rings with any two dips: mayo, sticky BBQ, ketchup, garlic mayo, sweet chilli, peri peri.',
      },
      {
        name: 'Garlic Baguette Slices (V)',
        price: '£3.85',
        description:
          'Four toasted slices with a garlic & parsley butter. Make it cheesy for £1.99 extra.',
      },
      {
        name: 'Tomato & Basil Soup (V, VE)',
        price: '£8.95',
        description: 'Served with freshly baked sourdough roll and butter.',
      },
      {
        name: 'Leek & Potato Soup (V)',
        price: '£8.95',
        description: 'Served with freshly baked sourdough roll and butter.',
      },
      {
        name: 'Cheese Savoury Sandwich (V)',
        price: '£9.25',
        description:
          'Served with crispy dressed side salad & your choice of crisps.',
      },
      {
        name: 'Breaded Camembert Rounds',
        price: '£9.95',
        description:
          'With freshly baked sourdough & caramelised red onion chutney. Add seasoned chips for £2.95.',
      },
      {
        name: 'Salt & Pepper Squid',
        price: '£9.25',
        description:
          'With sweet chilli sauce & creamy coleslaw. Add seasoned chips for £2.95.',
      },
      {
        name: 'Hoisin Duck Spring Rolls',
        price: '£8.85',
        description:
          'Eight crispy spring rolls with sweet chilli dip & creamy coleslaw. Add seasoned chips for £2.95.',
      },
      {
        name: 'American Style Boneless Wings',
        price: '£9.15',
        description:
          'Crispy fried boneless chicken wings in a classic American style coating, with creamy coleslaw. Add seasoned chips for £2.95.',
      },
    ],
  },
  {
    title: 'Chicken Wings',
    items: [
      {
        name: 'Chicken Wings',
        price: '£9.75',
        description:
          'All served with creamy coleslaw & sauce. Add seasoned chips for £2.95. Choose from: Tangy BBQ, Hot Peri Peri, Carolina Reaper or Buffalo.',
      },
    ],
  },
  {
    title: 'Fish Fryday Deal',
    items: [
      {
        name: '!! FISH FRYDAY - with any drink !!',
        price: '£19.95',
        description:
          'Choose from: Battered Atlantic cod fillet with seasoned chips, garden peas and bread & butter; OR 8 extra large Whitby scampi with seasoned chips, garden peas & crispy dressed salad; OR Moules Marinières with garlic baguette slices & seasoned chips.',
      },
    ],
  },
  {
    title: "Children's Meals",
    items: [
      { name: 'Sausage, Mash & Peas', price: '£7.95' },
      { name: 'Scampi & Chips', price: '£7.95' },
      { name: 'Grilled Halloumi Salad (V)', price: '£7.95' },
      { name: 'Fish Finger, Chips & Beans', price: '£7.95' },
      { name: 'Quorn Dippers, Chips & Peas (VG)', price: '£7.95' },
    ],
  },
  {
    title: 'Desserts',
    items: [
      {
        name: 'Warm Sticky Toffee Pudding (GF)',
        price: '£8.75',
        description: 'With vanilla pod ice cream & toffee sauce.',
      },
      {
        name: 'Hot Apple & Cinnamon Butter Crumble (GF)',
        price: '£8.55',
        description: 'With creamy Devon custard.',
      },
      {
        name: 'Sea Salt Caramel or Vanilla Pod Ice Cream',
        price: '£8.15',
        description: 'With toffee & chocolate sauces and wafers.',
      },
    ],
  },
];
